<template>
  <div class="main common-form-content">
    <div class="form-box">
      <el-form
          :model="formData"
          ref="form"
          size="normal"
          :show-message="false"
          :rules="rules">
        <div class="form-content">
          <el-form-item label="旧密码" prop="password">
            <el-input
                v-model="formData.password"
                placeholder="请输入"
                type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
                v-model="formData.newPassword"
                placeholder="请输入"
                type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="retypePassword">
            <el-input
                v-model="formData.retypePassword"
                placeholder="请输入"
                type="password"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-sub-box">
          <div class="submit-btn" :class="{'is-submit-state': mixin_submitBtnState}" @click="onSubmit">
            保存
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {loginOut, changePwd} from "@/api/newApi";
import {Toast} from "vant";
import {validate} from "@/mixins/mixin";

export default {
  mixins: [validate],
  data() {
    let validatePwd = (rule, value, callback) => {
      if (value === this.formData.newPassword) {
        callback();
      } else {
        callback(new Error("俩次输入的密码不正确"));
      }
    }
    return {
      formData: {},
      rules: {
        password: [{required: true, message: '请填写旧密码'}],
        newPassword: [{required: true, message: '请填写新密码'}],
        retypePassword: [
          {required: true, message: '请填写确认新密码'},
          {validator: validatePwd},
        ],
      },
    };
  },
  methods: {
    onSubmit(values) {
      this.$refs["form"].validate((valid, validObject) => {
        if (valid) {
          changePwd({
            password: this.formData.password,
            newPassword: this.formData.newPassword,
          }).then((res) => {
            if (res.message.code == 0) {
              Toast("密码修改成功");
              window.localStorage.removeItem("token");
              loginOut().then((res) => {
                if (res.message.code == 0) {
                  setTimeout(() => {
                    this.$router.push({
                      path: "/login",
                    });
                  }, 800);
                }
              });
            } else {
              Toast(res.message.message);
            }
          });
        } else {
          let toastMeg = Object.keys(validObject).map(key => {
            return validObject[key][0].message
          })
          Toast(toastMeg[0]);
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.main {
  min-height: 100%;
  background-color: #F5F5F6;

  .form-content {
    margin-bottom: 0.3rem;

    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 0;

        &:last-child {
          border-bottom: 0 !important;
        }
      }
    }
  }
}
</style>
